<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="mt-4" :loading="loading" :disabled="loading">
          <v-toolbar flat color="primary" dark class="justify-center">
            <v-toolbar-title>اثر ارسالی</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>
                <v-btn color="secondary" outlined block @click="get_next">
                                  اثر بعد

                </v-btn>
              </v-col>
              <v-col>
                <v-btn color="secondary" outlined block @click="get_prev">
                                  اثر قبل

                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <SubmissionCardAdmin :submission="data.submission"/>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12">
                    <v-btn block color="secondary"
                           @click="$router.push({name:'UserSubmissions',params:{id:data.submitter.id}})">
                      کل اثار کاربر
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <ProfileCard :user="data.submitter"/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <hr>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" v-for="(setting,index) in data.settings"
                     :key="setting.id">
                <Setting :loading="loading" v-model="data.settings[index]"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
    <EditSubmissionDialog/>
    <EditProfileDialog/>
    <ProfileEditableDialog/>
    <SubmissionEditableDialog/>
    <ChangeSubmitterDialog/>
  </v-container>
</template>

<script>
import static_config from "../common/Statics"
import Setting from "./SettingComponents/Setting";
import SubmissionCard from "../common/SubmissionCard";
import EditSubmissionDialog from './Dialogs/EditSubmissionDialog'
import EditCastDialogAdmin from "@/components/admin/Dialogs/EditCastDialogAdmin";
import EditProfileDialog from "./Dialogs/EditProfileDialog";
import {mapState} from "vuex";
import ProfileEditableDialog from "./Dialogs/ProfileEditableDialog";
import SubmissionEditableDialog from "./Dialogs/SubmissionEditableDialog";
import ProfileCard from "@/components/admin/Cards/ProfileCard";
import SubmissionCardAdmin from "@/components/admin/Cards/SubmissionCardAdmin";
import EditCastDialog from "@/components/dialogs/EditCastDialog";
import DeleteCastDialogAdmin from "@/components/admin/Dialogs/DeleteCastDialogAdmin";
import AddCastDialogAdmin from "@/components/admin/Dialogs/AddCastDialogAdmin";
import EditAttachmentsAdminDialog from "@/components/admin/Dialogs/EditAttachmentAdminDialog";
import DeleteAttachmentAdmin from "@/components/admin/Dialogs/DeleteAttachmentAdmin";
import AddAttachmentsAdminDialog from "@/components/admin/Dialogs/AddAttachmentAdminDialog";
import EditProfilePictureDialog from "@/components/admin/Dialogs/EditProfilePictureDialog";
import ChangeSubmitterDialog from "@/components/admin/Dialogs/ChangeSubmitterDialog";

export default {
  name: "SubmissionItem",
  mounted() {
    this.api_call();
  },

  components: {
    ChangeSubmitterDialog,
    SubmissionCardAdmin,
    ProfileCard,
    SubmissionEditableDialog,
    ProfileEditableDialog,
    EditProfileDialog,
    SubmissionCard,
    Setting,
    EditSubmissionDialog
  },
  computed: {
    ...mapState({
      data: state => state.Admin.admin.data,
      loading: state => state.Admin.admin.loading
    })
  },
  methods: {
    api_call() {
      this.$store.dispatch('get_submission_item', {id: this.$route.params.id}).catch(() => {
      })
    },
    get_next(){
      this.$store.dispatch('get_next_prev', {id : this.data.submission.id , next : true})
    },
    get_prev(){
      this.$store.dispatch('get_next_prev', {id : this.data.submission.id , next : false})
    }


  },
};
</script>

<style scoped>
</style>
